import { NovoPedidoRequest } from '../types/pagamento';

type Resultado = {
  [key: string]: unknown;
};

export function transformarPedido(pedido: NovoPedidoRequest): Resultado {
  const novoObjeto: Resultado = { ...pedido };

  const chavesParaProcessar: (keyof NovoPedidoRequest)[] = [
    'planoID',
    'comboID',
    'comboPlanoID',
  ];

  chavesParaProcessar.forEach((chave) => {
    const itens = pedido[chave] as { id: string }[];
    if (Array.isArray(itens) && itens.length > 0) {
      itens.forEach((item, index) => {
        novoObjeto[`${chave}[${index}]`] = item.id;
      });
    }
    delete novoObjeto[chave];
  });

  if (pedido?.dataVencimento) {
    const [mesVencimento, anoVencimento] = pedido.dataVencimento.split('/');
    novoObjeto.mesVencimento = mesVencimento;
    novoObjeto.anoVencimento = anoVencimento;
    delete novoObjeto.dataVencimento;
  }

  Object.keys(novoObjeto).forEach((key) => {
    if (Array.isArray(novoObjeto[key]) && novoObjeto[key].length === 0) {
      delete novoObjeto[key];
    }
  });

  return novoObjeto;
}
